import React from 'react';
import CircularProgress from 'components_base/CircularProgress';

const ETrNPage = React.lazy(() => import('../components/ETrNPage'));

function ETrNView(props: any) {
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <ETrNPage {...props} />
    </React.Suspense>
  );
}

export default ETrNView;
